/* eslint-disable jsx-a11y/anchor-is-valid */
import { useState } from 'react';
import '../../styles/login.scss';
import '../../styles/app.css';
import { MuiThemeProvider, createMuiTheme } from '@material-ui/core/styles';
import { DerbySoftMUItheme } from '../../styles/muiTheme';
import { Layout } from 'antd';
import Sidebar from '../Sidebar';
import { SideBarStatusProvider } from '../../store/sidebarContext';
import welcome from '../../styles/assets/password.png';
import groupSvg from '../../styles/assets/ContentSuiteBlue.svg';
import ButtonDinamyc from '../ButtonDinamyc';
import { pingLogOut } from '../../helpers/ping';
import { useSession } from '../../store/sessionContext';

const theme = createMuiTheme(DerbySoftMUItheme);

const PropertyConnector = () => {
  const { Content } = Layout;

  const [subMenuStatus, setSubMenuStatus] = useState<boolean>(false);
  const [hasFocus, setHasFocus] = useState<boolean>(false);
  const { session } = useSession();

  const logOut = async () => {
    return await pingLogOut({ token: session.token });
  };

  return (
    <MuiThemeProvider theme={theme}>
      <Layout className='site-layout'>
        <SideBarStatusProvider>
          <Sidebar
            subMenuStatus={subMenuStatus}
            setSubMenuStatus={setSubMenuStatus}
            setHasFocus={setHasFocus}
            hasFocus={hasFocus}
            short={true}
            showMenu={false}
          />
          <Layout className='site-layout'>
            <Content>
              <div className='container'>
                <section className='p-10'>
                  <img src={groupSvg} alt='content suite title' />
                </section>
                <section className='sub-container'>
                  <img src={welcome} alt='login welcome' />
                  <div className='sub-container-message'>
                    <b>Sorry, it looks like you do not have access to this product</b>
                    <br />
                    <br />
                    <p>
                      We offer flexible pricing options dependent on your overall requirements. Please Contact Us for
                      more information
                    </p>
                    <ButtonDinamyc
                      message='Contact Us'
                      classes='buttonContactUs'
                      action={() => (window.location.href = 'https://www.derbysoft.com/content/')}
                    />
                    <br />
                    <br />
                    <p className='learnMore'>
                      To learn more about Content Suite, please
                      <a className='pl-3' href='https://www.derbysoft.com/content/'>
                        Click Here.
                      </a>
                    </p>
                    <p className='learnMore'>
                      To clear all your local browser credentials, please
                      <a className='pl-3' href='#' onClick={() => logOut()}>
                        Click Here.
                      </a>
                    </p>
                  </div>
                </section>
              </div>
            </Content>
          </Layout>
        </SideBarStatusProvider>
      </Layout>
    </MuiThemeProvider>
  );
};

export default PropertyConnector;
